// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607030838/js/" + chunkId + "." + {"44":"a1548b0e","225":"57d6b8b3","481":"e0a53b7c","486":"181de06b","770":"99590863"}[chunkId] + ".0.46793454122199996.chunk.js";
};